import { Flex, Modal, Text } from "@wayflyer/flyui";
import { RhfDropdownField } from "@wayflyer/flyui-hook-form";
import { useIntl } from "react-intl";

import type { useBankControllerContext } from "../../hooks/bank-controller-context";
import { MESSAGES } from "../message-definitions";

type ConnectModalProps = Pick<
  ReturnType<typeof useBankControllerContext>,
  "countryForm" | "countryOptions" | "defaultCountry" | "isConnectionUnsupportedCountry" | "isConnecting"
> & {
  isOpen: boolean;
  onClose: () => void;
  onContinue: () => void;
};

export const ConnectModal = ({
  isOpen,
  onClose,
  onContinue,
  countryForm,
  countryOptions,
  defaultCountry,
  isConnectionUnsupportedCountry,
  isConnecting,
}: ConnectModalProps) => {
  const intl = useIntl();

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={intl.formatMessage(MESSAGES.connectModalTitle)}
      primaryAction={{
        content: intl.formatMessage(MESSAGES.connectModalContinue),
        onAction: onContinue,
        loading: isConnecting,
        disabled: isConnectionUnsupportedCountry,
      }}
    >
      <Flex direction="column" gap="4">
        <Text color="placeholder">{intl.formatMessage(MESSAGES.connectModalBody)}</Text>
        <RhfDropdownField
          name="country"
          initialValue={defaultCountry?.code}
          options={countryOptions}
          form={countryForm}
          label={intl.formatMessage(MESSAGES.bankLocationLabel)}
        />
      </Flex>
    </Modal>
  );
};
